export default "__VITE_ASSET__DvIoYhmn__"